"use client";

import { type ComponentProps, forwardRef, useState } from "react";
import { EyeClosedLinear, EyeLinear } from "solar-icon-set";
import { Input } from "../Input";

export interface PasswordInputProps extends Omit<ComponentProps<typeof Input>, "type" | "endContent"> {
  /**
   * Accessible label for the visibility toggle button.
   * @default "toggle password visibility"
   */
  toggleAriaLabel?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ toggleAriaLabel = "toggle password visibility", ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
      <Input
        ref={ref}
        type={isVisible ? "text" : "password"}
        endContent={
          <button
            aria-label={toggleAriaLabel}
            className="cursor-pointer rounded-sm outline-transparent focus-visible:outline-2 focus-visible:outline-primary"
            type="button"
            onClick={() => setIsVisible(!isVisible)}
          >
            {isVisible ? (
              <EyeLinear className="size-5 text-default-500" />
            ) : (
              <EyeClosedLinear className="size-5 text-default-500" />
            )}
          </button>
        }
        {...props}
      />
    );
  },
);

PasswordInput.displayName = "PasswordInput";
